/**
 * Force homepage/slideshow hero videos to keep playing.
 * Browsers (especially mobile and email in-app browsers) often block or interrupt autoplay;
 * Prestige then enables native controls and shows a play button. This retries muted playback
 * on every load and after resume, without requiring the visitor to tap play.
 */
(function () {
  var SELECTOR = '.slideshow video-media[autoplay] video, slideshow-carousel video-media[autoplay] video';

  function isVisible(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      try {
        return el.checkVisibility({ checkOpacity: false, checkVisibilityCSS: true });
      } catch (e) {
        /* fall through */
      }
    }
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function prepareAndPlay(video) {
    if (!video || !isVisible(video)) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.loop = true;
    video.removeAttribute('controls');
    video.controls = false;

    var mediaHost = video.closest('video-media');
    if (mediaHost) {
      mediaHost.removeAttribute('suspended');
      mediaHost.removeAttribute('show-play-button');
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise
        .then(function () {
          if (mediaHost) {
            mediaHost.setAttribute('playing', '');
            mediaHost.setAttribute('loaded', '');
            mediaHost.removeAttribute('suspended');
          }
        })
        .catch(function () {
          /* Browser may still block until a later interaction; keep retrying. */
        });
    }
  }

  function forceHeroVideos() {
    document.querySelectorAll(SELECTOR).forEach(prepareAndPlay);
  }

  var scheduled = false;
  function scheduleForce() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      forceHeroVideos();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceHeroVideos, { once: true });
  } else {
    forceHeroVideos();
  }

  window.addEventListener('pageshow', scheduleForce);
  window.addEventListener('load', scheduleForce);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') scheduleForce();
  });

  // Brief retry window covers slow network + email-to-site navigations.
  var attempts = 0;
  var retryTimer = window.setInterval(function () {
    forceHeroVideos();
    if (++attempts >= 20) window.clearInterval(retryTimer);
  }, 400);

  // If autoplay is still blocked, the first real gesture unlocks muted play without a visible play button.
  ['pointerdown', 'touchstart', 'click', 'scroll'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function () {
        forceHeroVideos();
      },
      { passive: true, capture: true, once: true }
    );
  });
})();
